import React, { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import ImageUploader from '../../components/ImageUploader';
import LoadingSpinner from '../../components/LoadingSpinner';
import {
  PageHeader, Panel, FormGrid, FormGroup, SaveBtn, Toast, Row,
} from './styles/AdminStyles';

const EditHome = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    api.get('/home').then(d => { setData(d); setLoading(false); });
  }, []);

  if (loading || !data) return <LoadingSpinner fullPage />;

  const onField = (field) => (e) => setData({ ...data, [field]: e.target.value });
  const onImage = (field) => (val) => setData({ ...data, [field]: val });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    setToast(null);
    try {
      const saved = await api.put('/home', data);
      setData(saved);
      api.clearCache();
      setToast({ type: 'success', message: 'Home page saved.' });
    } catch (err) {
      setToast({ type: 'error', message: err.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save}>
      <PageHeader>
        <div className="eyebrow">Content</div>
        <h1>Edit Home Page</h1>
        <p>Manage the hero, page banner and intro copy on the home page.</p>
      </PageHeader>

      <Panel>
        <h2>Site Logo</h2>
        <div className="subtitle">Displayed in the website header. Use a transparent PNG or SVG for best results.</div>
        <ImageUploader
          label="Logo Image"
          value={data.logo}
          onChange={onImage('logo')}
          onRemove={() => onImage('logo')('')}
        />
      </Panel>

      <Panel>
        <h2>Hero Section</h2>
        <div className="subtitle">The large area at the top of the home page.</div>
        <FormGrid $cols={2}>
          <FormGroup>
            <label>Hero Title</label>
            <input value={data.heroTitle || ''} onChange={onField('heroTitle')} />
          </FormGroup>
          <FormGroup>
            <label>Hero Description</label>
            <input value={data.heroDescription || ''} onChange={onField('heroDescription')} />
          </FormGroup>
        </FormGrid>
        <ImageUploader
          label="Hero Image"
          value={data.heroImage}
          onChange={onImage('heroImage')}
          onRemove={() => onImage('heroImage')('')}
        />
      </Panel>

      <Panel>
        <h2>Page Intro</h2>
        <div className="subtitle">Appears beneath the hero as the welcome / introduction block.</div>
        <ImageUploader
          label="Page Banner Image"
          value={data.bannerImage}
          onChange={onImage('bannerImage')}
          onRemove={() => onImage('bannerImage')('')}
        />
        <FormGroup>
          <label>Title</label>
          <input value={data.title || ''} onChange={onField('title')} />
        </FormGroup>
        <FormGroup>
          <label>Description</label>
          <textarea value={data.description || ''} onChange={onField('description')} />
        </FormGroup>
      </Panel>

      <Row>
        <SaveBtn type="submit" disabled={saving}>{saving ? 'Saving...' : 'Save Changes'}</SaveBtn>
        {toast && <Toast $error={toast.type === 'error'}>{toast.message}</Toast>}
      </Row>
    </form>
  );
};

export default EditHome;
